// extracted by mini-css-extract-plugin
export default {"footer":"hXQ4OH","stepActionContainer":"gphKSO"};